module.exports = __webpack_public_path__ + "/img/OscJL-Custom-Footprint-9OXtxp.svg";